import { SvgIcon } from '@mui/material';

export const ToastSuccessIcon = ({ stroke = "#0AD626", ...props }) => (
    <SvgIcon viewBox="0 0 23 22" {...props}>
        <g fill="none">
            <path
                d="M11.5002 20.1673C16.5418 20.1673 20.6668 16.0423 20.6668 11.0007C20.6668 5.95898 16.5418 1.83398 11.5002 1.83398C6.4585 1.83398 2.3335 5.95898 2.3335 11.0007C2.3335 16.0423 6.4585 20.1673 11.5002 20.1673Z"
                stroke={stroke}
                strokeWidth="1.375"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.604 11.0004L10.1982 13.5945L15.3957 8.40625"
                stroke={stroke}
                strokeWidth="1.375"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </SvgIcon>
);
